"use client";

import { PreviewAdapter, useEditorPreviewRenderArgs } from "@/features/previews";

import { QRPreviewStyle } from "./QRPreviewStyle";

import { QRPreviewProps } from "./types";

import "./styles.scss";

export const QRPreviewData = ({
  data,
  previewTranslations,
  isQRInit,
  defaultPreviewTitle,
}: QRPreviewProps) => {
  const previewAdapterProps = useEditorPreviewRenderArgs({
    data,
    previewTranslations,
    isQRInit,
  });

  if (!data?.type) {
    return (
      <div className="qr-preview__layout__image">
        <QRPreviewStyle
          data={data}
          defaultPreviewTitle={defaultPreviewTitle}
          showEmptyPreview
        />
      </div>
    );
  }

  if (!previewAdapterProps) {
    return <div className="qr-preview__layout__image" />;
  }

  return (
    <div className="qr-preview__layout__image">
      <PreviewAdapter {...previewAdapterProps} />
    </div>
  );
};
